import HttpError from './HttpError';

export default class ResourceNotFoundError extends HttpError {}
